import React, { useEffect, useLayoutEffect, useState } from 'react';
import './Navbar.scss';

const navItems = [
  { id: 'capabilities', label: 'Capabilities' },
  { id: 'work', label: 'Work' },
  { id: 'experience', label: 'Experience' },
  { id: 'contact', label: 'Contact' },
];

const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [progress, setProgress] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  useLayoutEffect(() => {
    const updateScrollState = () => {
      const doc = document.documentElement;
      const scrollable = doc.scrollHeight - doc.clientHeight;
      setProgress(scrollable > 0 ? (window.scrollY / scrollable) * 100 : 0);
      setIsScrolled(window.scrollY > 10);
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateScrollState();
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    updateScrollState();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const scrollToTop = (e: React.MouseEvent) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setMenuOpen(false);
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <div className="scroll-progress" style={{ width: `${progress}%` }} />
      <nav className={`nav ${isScrolled ? 'nav--scrolled' : ''}`}>
        <a href="#top" className="nav__brand" onClick={scrollToTop} data-cursor-hover>
          RYAN&nbsp;CHONG
        </a>

        <div className="nav__links">
          {navItems.map((item) => (
            <a key={item.id} href={`#${item.id}`} className="nav__link" data-cursor-hover>
              {item.label}
            </a>
          ))}
        </div>

        <button
          type="button"
          className="nav__toggle"
          aria-expanded={menuOpen}
          aria-controls="nav-mobile-menu"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span className="nav__toggle-line" />
          <span className="nav__toggle-line" />
        </button>
      </nav>

      <div
        id="nav-mobile-menu"
        className={`nav__mobile ${menuOpen ? 'nav__mobile--open' : ''}`}
        aria-hidden={!menuOpen}
      >
        {navItems.map((item) => (
          <a
            key={item.id}
            href={`#${item.id}`}
            className="nav__mobile-link"
            onClick={closeMenu}
            data-cursor-hover
          >
            {item.label}
          </a>
        ))}
      </div>
    </>
  );
};

export default Navbar;
